import { INotificationSetting } from "@cai-services";
import { NotificationType } from "./notification-type.model";
import { User } from "./user.model";

export class NotificationSetting implements INotificationSetting {
  isSendEmail: boolean;
  isSendToast: boolean;
  user: User;
  notificationType: NotificationType;
  isPushNotApplicable?: boolean;
  isEmailNotApplicable?: boolean;

  constructor (isSendEmail?: boolean, isSendToast?: boolean) {
    this.isSendEmail = isSendEmail;
    this.isSendToast = isSendToast;
  }
}
